import Vue from "vue";
import VueResource from "vue-resource";
import { API_ROOT } from "../config";
Vue.use(VueResource);
export default {
  request(projectId, path, method = "get", input = {}) {
    if (!projectId || !/^[a-z0-9_.%/-]+$/i.test(path))
      throw new Error("Projekt und gültiger Runtime-Pfad erforderlich");
    const resource = Vue.resource(
      API_ROOT + "agent-projects/{projectId}/runtime/" + path
    );
    if (method === "get") return resource.get({ projectId, ...input });
    if (method === "put") return resource.update({ projectId }, input);
    if (method === "delete") return resource.delete({ projectId });
    return resource.save({ projectId }, input);
  },
};
